import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import { Drawer, Space, Pagination, Tooltip } from 'antd';
import Dropzone from 'react-dropzone-uploader';
import { v1 as uuid } from 'uuid'
import 'react-dropzone-uploader/dist/styles.css'
import { Modal } from 'react-bootstrap';
import Select, { components } from 'react-select';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { useTheme } from "./theme-provider.js"
import { getCookie, setCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import formatNumber from '../common_component/formatNumber.js';
import StatusBadge from '../common_component/StatusBadge.js';
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";

export const ExpenseList = () => {
    let [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()
    const daterange_picker_ref = useRef();

    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"));
    const [CurrencySymbol, setCurrencySymbol] = useState("");
    const [expense_id, setexpense_id] = useState("");
    const [submitButtonState, setSubmitButtonState] = useState(false);

    let [fileNames, setFileNames] = useState([])
    const [fileSessionUniqueId, setFileSessionUniqueId] = useState(uuid());
    const [additonalDetailsFlag, setAdditonalDetailsFlag] = useState(false);

    const [PaidThroughAccountlist, setPaidThroughAccountlist] = useState([]);
    const [PaidThroughAccount, setPaidThroughAccount] = useState(null);
    const [payExpensePermission, setPayExpensePermission] = useState(false);

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Expense_details, setExpense_details] = useState(null);
    const [Payment_details, setPayment_details] = useState([]);
    const [Expense_history_details, setExpense_history_details] = useState([]);
    const [Expense_document_details, setExpense_document_details] = useState([]);
    const [Expense_recurrence_details, setExpense_recurrence_details] = useState(null);
    const [open, setOpen] = useState(false);
    const [cancel_type, setcancel_type] = useState("");

    const [expenseList, setExpenseList] = useState([]);
    const [status, setstatus] = useState("");

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [ImageModalShow, setImageModalShow] = useState(false);
    const [Image_src, setImage_src] = useState(false);

    const [approveModalShow, setApproveModalShow] = useState(false);
    const [approveType, setApproveType] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState('')
    const [totalExpenseListLength, setTotalExpenseListLength] = useState(0);
    const [expenseListApiState, setExpenseListApiState] = useState(false);

    const [profileName, setprofileName] = useState("")
    const [scheduleStartDate, setScheduleStartDate] = useState(moment().utc().format("YYYY-MM-DD"))
    const [scheduleEndDate, setScheduleEndDate] = useState(moment().utc().add(7, "days").format("YYYY-MM-DD"))
    const [frequencyDetails, setFrequencyDetails] = useState({ frequency: 1, time_period: "week", week_day: [], month_date: 1, month: 1 })
    const [allDayCheck, setAllDayCheck] = useState(true)
    const [startTime, setStartTime] = useState(new Date().getHours() + ":" + new Date().getMinutes())
    const [endTime, setEndTime] = useState((new Date().getHours() + 5) >= 23 ? "23:59" : (new Date().getHours() + 5) + ":" + new Date().getMinutes())

    const [RemoveAttachmentModalShow, setRemoveAttachmentModalShow] = useState(false);
    const [RemoveAttachmentDetails, setRemoveAttachmentDetails] = useState(null);
    const [MakeRecurringModalShow, setMakeRecurringModalShow] = useState(false);
    const [CancelRecurringModalShow, setCancelRecurringModalShow] = useState(false);
    const [StatusModalShow, setStatusModalShow] = useState(false);
    const [reason, setReason] = useState("");
    const [paidStatusModalShow, setPaidStatusModalShow] = useState(false);

    const [statusType, setStatusType] = useState("All");
    const statusTypeArray = ["EXPENSE_DRAFT", "EXPENSE_PENDING_APPROVAL", "EXPENSE_CANCELLED", "EXPENSE_REJECTED", "EXPENSE_APPROVED", "EXPENSE_PAID"]
    const apiController = useRef(new AbortController())

    var page_name = "expense-list";

    const { user, read, write, visibility, organization_id, user_role, actionPermissionDetails } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    const onRowClick = (temp_obj) => {
        let tempData = temp_obj;
        setOpen(true);
        setnavtype("Overview");
        tempData.ApproveButtonShow = false;
        tempData.ApproveFinalButtonShow = false;
        tempData.PaidButtonShow = false;

        let t1 = JSON.parse(tempData.approval_info)
        let t2 = tempData.add_status
        let t3 = tempData.approval_level
        let t4 = t1.value.length
        if (t2 == "EXPENSE_PENDING_APPROVAL") {
            if (t1.type == "multilevel_approval") {

                let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
                if (tl.includes(user.email)) {
                    tempData.ApproveButtonShow = true;
                }
            }
            else if (t1.type == "custom_approval") {
                let ty = t1.value[0]
                if (ty.user_type == "Group User") {
                    if (ty.user_value.includes(user_role)) {
                        tempData.ApproveButtonShow = true;
                    }
                }
                else if (ty.user_type == "Individual User") {
                    if (ty.user_value.includes(user.email)) {
                        tempData.ApproveButtonShow = true;
                    }
                }
            }
            if (user_role == "Admin") {
                tempData.ApproveFinalButtonShow = true;
            }
        }
        else if (t2 === "EXPENSE_APPROVED") {
            if (user_role == "Admin") {
                tempData.PaidButtonShow = true;
            }
            else if (payExpensePermission) {
                ///depends on profile settings
                tempData.PaidButtonShow = true;
            }
        }
        setExpense_details(tempData);
        setCurrencySymbol(tempData.currency.currency_symbol);
        setPayment_details(tempData.account_details);
        //setExpense_history_details(tempData.expense_history_details);
        getExpenseAdditionalDetails(tempData.unique_id, true);
    }

    async function getExpenseAdditionalDetails(id, flag) {
        setAdditonalDetailsFlag(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/expense-additional-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "flag": flag, "document_flag": true, "history_flag": true, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setExpense_history_details(body.data.expense_history_details);
            setExpense_document_details(body.data.expense_document_details);
            setExpense_recurrence_details(body.data.recurrence_details[0]);
            setAdditonalDetailsFlag(false);
        }
        else {
            throw "expense additional details api error"
        }
    }

    async function selectiveaccounthead() {
        let arr = [
            { "category_name": "Assets", "headArray": [] },
            { "category_name": "Equity", "headArray": [] },
            { "category_name": "Income", "headArray": [] },
            { "category_name": "Bank", "headArray": [] }
        ]
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/selective-account-head`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "headRequest": arr, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            let temp_dropdown_paid = [];
            let temp_dropdown = [];
            body.data.map((obj) => {
                var temp_obj = {};
                temp_obj.label = obj.category_name;
                temp_obj.id = obj.cid;
                let temp_dropdown1 = [];
                obj.headArray.map((obj1) => {
                    var temp_obj1 = {};
                    temp_obj1.label = obj1.name;
                    temp_obj1.value = obj1.hid;
                    temp_dropdown1.push(temp_obj1);
                })
                temp_obj.options = temp_dropdown1;
                temp_dropdown_paid.push(temp_obj);
            })
            setPaidThroughAccountlist(temp_dropdown_paid);
        }
    }

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    useEffect(() => {
        if (user_role == "Admin") {
            setPayExpensePermission(true);
        }
        else {
            setPayExpensePermission(actionPermissionDetails.find(option => option.key == "Expense")?.items?.find(option => option.key == "Pay Expense")?.value == 1 ? true : false);
        }
    }, [actionPermissionDetails])

    const onClose = () => {
        setOpen(false);
        setExpense_history_details([]);
        setCurrencySymbol("");
        setExpense_details(null);
    };

    const handleRecurringExpenseModalClose = () => {
        setprofileName("");
        setAllDayCheck(true);
        setFrequencyDetails({ frequency: 1, time_period: "week", week_day: [], month_date: 1, month: 1 });
        setScheduleStartDate(moment().utc().format("YYYY-MM-DD"));
        setScheduleEndDate(moment().utc().add(7, "days").format("YYYY-MM-DD"));
        setMakeRecurringModalShow(false);
    }

    async function getExpenseList(start, end, page_number, Size, search_val, st) {
        try {
            var object = {};
            object.email = user.email;
            if (expenseListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setExpenseListApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/show-expense`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_val, "status_type": st, "currentPage": page_number, "rows_per_page": Size, "start_date": start, "end_date": end, "organization_id": organization_id, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation == "success") {
                var temp_data = [];
                body.data.list.map((obj) => {
                    var temp_obj = {};
                    temp_obj.expense_id = obj.unique_id;
                    temp_obj.branch_name = obj.branch_name;
                    if (obj.expense_type == "Customize Expense") {
                        temp_obj.expense_for = obj.expense_for;
                        temp_obj.User = obj.expense_user_name;
                    }
                    else {
                        temp_obj.expense_for = "---";
                        temp_obj.User = "---";
                    }

                    temp_obj.Expense_Number = obj.expense_number;
                    temp_obj.add_date_time = moment(obj.add_date_time).format('lll');
                    temp_obj.add_status = obj.add_status;
                    if (obj.recurrence_expense_flag) {
                        temp_obj.recursive_status = <span className="badge badge-primary">Recursive</span>
                    }
                    else {
                        temp_obj.recursive_status = <span className="badge badge-secondary">Non Recursive</span>
                    }

                    temp_obj.Amount = obj.account_details.reduce((p, o) => { return p + Number(o.total_amount) }, 0);
                    temp_obj.Expense_Date = moment(obj.expense_date).format('ll');
                    temp_obj.currency_info = obj.currency;
                    //let status=obj.add_status;

                    let ApproveButtonShow = false;
                    let PaidButtonShow = false;
                    let ApproveFinalButtonShow = false;

                    let t1 = JSON.parse(obj.approval_info)
                    let t2 = obj.add_status
                    let t3 = obj.approval_level
                    let t4 = t1.value.length
                    if (t2 == "EXPENSE_PENDING_APPROVAL") {
                        if (t1.type == "multilevel_approval") {

                            let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
                            if (tl.includes(user.email)) {
                                ApproveButtonShow = true;
                            }
                        }
                        else if (t1.type == "custom_approval") {
                            let ty = t1.value[0]
                            if (ty.user_type == "Group User") {
                                if (ty.user_value.includes(user_role)) {
                                    ApproveButtonShow = true;
                                }
                            }
                            else if (ty.user_type == "Individual User") {
                                if (ty.user_value.includes(user.email)) {
                                    ApproveButtonShow = true;
                                }
                            }
                        }
                        if (user_role == "Admin") {
                            ApproveFinalButtonShow = true;
                        }
                    }
                    else if (t2 === "EXPENSE_APPROVED") {
                        if (user_role == "Admin") {
                            PaidButtonShow = true;
                        }
                        else if (payExpensePermission) {
                            ///depends on profile settings
                            PaidButtonShow = true;
                        }
                    }
                    temp_obj.approval_info = obj.approval_info;
                    temp_obj.id = obj.unique_id;
                    var id = obj.unique_id;
                    temp_obj.actions =
                        <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                            {
                                write &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li className="py-1"><a onClick={(e) => { onRowClick(obj) }} className={`dropdown-item cursor-pointer`}>View Expense</a></li>
                                    {(obj.add_status === "EXPENSE_DRAFT" || obj.add_status == "EXPENSE_PENDING_APPROVAL") &&
                                        <li className="py-1"><Link to={`/edit-expense-details/${obj.unique_id}`} className={`dropdown-item cursor-pointer`}>Edit Details</Link></li>}
                                    {obj.recurrence_expense_flag == false &&
                                        <li className="py-1"><a onClick={(e) => { makeRecurring(id); }} className={`dropdown-item cursor-pointer`}>Make Recurring</a></li>}
                                    {obj.recurrence_expense_flag == true && obj.recurrence_expense_status == "Active" &&
                                        <li className="py-1"><a onClick={(e) => { cancelRecurring(id, obj.recurrence_expense_status); }} className={`dropdown-item cursor-pointer`}>Cancel Recurring</a></li>}
                                    {PaidButtonShow &&
                                        <li className="py-1"><a onClick={(e) => { updateStatus(id, "paid", obj.add_status); }} className={`dropdown-item cursor-pointer`}>Pay expense</a></li>}
                                    {(user_role == "Admin" && (obj.add_status !== "EXPENSE_PAID" && obj.add_status !== "EXPENSE_APPROVED" && obj.add_status !== "EXPENSE_CANCELLED" && obj.add_status !== "EXPENSE_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("cancelled"); updateStatus(obj.unique_id, "status", obj.add_status); }} style={{ cursor: "pointer" }} className={`dropdown-item cursor-pointer`}>Cancel</a></li>}
                                    {(user_role == "Admin" && (obj.add_status !== "EXPENSE_PAID" && obj.add_status !== "EXPENSE_APPROVED" && obj.add_status !== "EXPENSE_CANCELLED" && obj.add_status !== "EXPENSE_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("rejected"); updateStatus(obj.unique_id, "status", obj.add_status); }} className={`dropdown-item cursor-pointer`}>Reject</a></li>}
                                    {(ApproveButtonShow) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(obj.unique_id, "approve", obj.add_status); }} className={`dropdown-item cursor-pointer`}>Final Approve</a></li>}
                                    {(ApproveFinalButtonShow) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(obj.unique_id, "approve", obj.add_status); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                </ul>
                            }
                        </div>

                    temp_data.push(temp_obj);
                })
                setExpenseList(temp_data);
                setTotalExpenseListLength(body.data.count);
                setExpenseListApiState(false);
            }
            //console.log("count",body.data.count)

        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType);
            let p2 = selectiveaccounthead();
            Promise.all([p1, p2])
                .then(() => {
                    setstate(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
        }
    }, [startDate, endDate, currentPage, rowsPerPage, searchValue, statusType])

    const approveExpenseSubmit = (final_flag, cancel_flag, paid_flag, cancel_msg, id) => {
        var object = {};
        object.final_flag = final_flag
        object.cancel_flag = cancel_flag
        object.paid_flag = paid_flag
        if (paid_flag) {
            if (PaidThroughAccount === null) {
                swal("Warning!", "Select a Paid through account", "warning");
                return
            }
            else {
                object.paid_through_account = PaidThroughAccount.value;
                object.account_category = PaidThroughAccountlist.find(x => x.options.map(a => a.value).includes(PaidThroughAccount.value)).id;
            }
        }
        object.cancel_msg = cancel_msg
        object.id = id
        object.user_email = user.email
        object.user_role = user_role

        object.organization_id = organization_id
        object.page_name = page_name;

        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-expense-details`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                if (paid_flag) {
                    swal("Great!", `Expense Paid successfully!`, "success").then(() => {
                        setPaidStatusModalShow(false);
                        getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
                    })
                }
                else {
                    swal("Great!", `Expense Approved successfully!`, "success").then(() => {
                        setApproveModalShow(false);
                        getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
                    })
                }

            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const makeRecurring = (id) => {
        setexpense_id(id);
        setMakeRecurringModalShow(true);
    }

    const cancelRecurring = (id, recurrence_expense_status) => {
        setexpense_id(id);
        setCancelRecurringModalShow(true);
        setstatus(recurrence_expense_status);
    }

    const updateStatus = (id, flag, add_status) => {
        setexpense_id(id);
        setstatus(add_status);
        if (flag == "paid") {
            setPaidStatusModalShow(true);
        }
        else if (flag == "approve") {
            setApproveModalShow(true);
        }
        else {
            setStatusModalShow(true);
        }
    }


    function getExtension(path) {
        var basename = path.split(/[\\/]/).pop(),  // extract file name from full path ...
            // (supports `\\` and `/` separators)
            pos = basename.lastIndexOf(".");       // get last position of `.`

        if (basename === "" || pos < 1)            // if file name is empty or ...
            return "";                             //  `.` not found (-1) or comes first (0)

        return basename.slice(pos + 1);            // extract extension ignoring `.`
    }

    const Preview = ({ fileWithMeta: { remove }, meta }) => {
        const { name, percent, status, previewUrl } = meta;
        // console.log(name)
        return (

            <div className="preview-box">
                <img src={previewUrl} style={{ maxHeight: "80px", maxWidth: "80px", borderRadius: "4px", marginRight: "10px" }} />
                <span title={name} className="name">{name.length >= 10 ? name.slice(0, 10) + "...." : name}</span> - <span className="status">{(status === "done") ? "Successfully Uploaded" : status}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span> && <span className="dzu-previewButton remove" onClick={remove} >
                    <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                        <g>
                            <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                        </g>
                    </svg>
                </span>}
                {
                    status === "done" &&
                    <span className="dzu-previewButton remove" onClick={remove} >
                        <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                            <g>
                                <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                            </g>
                        </svg>
                    </span>
                }
            </div>
        )
    }

    const handleChangeStatus = ({ meta }, status, allFiles) => {
        const { name } = meta;

        if (status === 'done') {
            setMainSubmitButtonState(false)
            setFileNames([...fileNames, name])
        }
        else if (status === 'removed') {
            setMainSubmitButtonState(false)
            let temp = [...fileNames]
            temp.splice(temp.indexOf(name), 1)
            setFileNames(temp)
        }
        else if (status === "error_file_size") {
            allFiles[0].remove()
            swal("Oops!", "File size exceeded", "warning");
        }
    };

    const getUploadParams = ({ file }) => {

        const body = new FormData();
        body.append('dataFiles', file);
        body.append('unique_id', fileSessionUniqueId);
        body.append('organization_id', organization_id);
        body.append('user_id', user.email);
        body.append('page_name', page_name);

        let headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "token": getCookie("access_token")
        }

        setMainSubmitButtonState(true)
        return { url: `${process.env.REACT_APP_SERVER_URL}/upload-expense-documents`, headers, body }
    }


    const submitRecurringExpensedetails = (e) => {
        e.preventDefault();
        if (profileName.trim() == "") {
            swal("Oops!", "Recurring Expense Name cannot be empty", "error");
            return
        }
        if (scheduleStartDate == "") {
            swal("Oops!", "Select a Start Date", "error");
            return
        }
        if (scheduleEndDate == "") {
            swal("Oops!", "Select an End Date", "error");
            return
        }
        if (frequencyDetails.frequency < 1) {
            swal("Oops!", "Frequency cannot be less than 1", "error");
            return
        }

        if (!allDayCheck) {
            if (startTime == "") {
                swal("Oops!", "Select a Start Time", "error");
                return
            }
            if (endTime == "") {
                swal("Oops!", "Select an End Time", "error");
                return
            }
        }

        var object = {};
        object.expense_id = expense_id
        object.profile_name = profileName
        object.start_date = scheduleStartDate
        object.end_date = scheduleEndDate

        let t = { ...frequencyDetails }
        if (frequencyDetails.time_period == "day") {
            delete t.week_day
            delete t.month_date
            delete t.month
        }
        else if (frequencyDetails.time_period == "week") {
            delete t.month_date
            delete t.month
        }
        else if (frequencyDetails.time_period == "month") {
            delete t.week_day
            delete t.month
        }
        else if (frequencyDetails.time_period == "year") {
            delete t.week_day
        }
        object.frequency_details = t

        object.all_day_check = allDayCheck
        object.start_time = allDayCheck ? null : startTime
        //object.end_time = allDayCheck?null:endTime

        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/make-expense-recurring`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Expense details mark as recurring successfully!", "success").then(() => {
                    handleRecurringExpenseModalClose();
                    getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
                })
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const showImage = (src) => {
        setImage_src(src);
        setImageModalShow(true);
    }

    const submitattachments = (val) => {
        if (fileNames.length > 0) {
            var values = { "expense_id": val, "unique_id": fileSessionUniqueId, 'filenames': fileNames, "page_name": page_name, "organization_id": organization_id };
            setMainSubmitButtonState(true)
            var headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "*/*",
                    "token": getCookie("access_token")
                }
            }

            axios.post(`${process.env.REACT_APP_SERVER_URL}/save-expense-document-details`, values, headers).then((res) => {
                setMainSubmitButtonState(false)
                if (res.data && res.data.operation == "success") {
                    swal("Great!", "Expense attachments saved successfully!", "success").then((value) => {
                        setOpen(false);
                    });
                }
                else {
                    swal("Oops!", "Something went wrong!", "error");
                }
            });
        }
    }

    const removeattachments = (val) => {
        let image_id = RemoveAttachmentDetails.unique_id;
        let file_name = RemoveAttachmentDetails.file_name;
        let original_file_name = RemoveAttachmentDetails.original_file_name;
        var values = { "image_id": image_id, "file_name": file_name, "original_file_name": original_file_name, "folder": "expense_documents", "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/delete-expense-document`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Expense attachments removedj successfully!", "success").then((value) => {
                    setRemoveAttachmentModalShow(false);
                    setOpen(false);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const cancelExpense = (e) => {
        e.preventDefault();
        if (reason == "") {
            swal("Warning!", `Need a specific reason for Cancel/Reject`, "warning");
            return false;
        }
        var values = { "id": expense_id, "cancel_type": cancel_type, "save_flag": true, "reason": reason, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-expense`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Expense cancelled successfully!", "success").then((value) => {
                    setStatusModalShow(false);
                    getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const cancelRecurrence = (e) => {
        e.preventDefault();

        var values = { "id": expense_id, "save_flag": true, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-recurrence-expense`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Recurrence cancelled successfully!", "success").then((value) => {
                    setCancelRecurringModalShow(false);
                    getExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Expense List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/expenses#regular-expense-list`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <Link to={`/add-expense`} className="btn btn-sm btn-primary me-3 rounded">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                    </path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create Expense</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        {(startDate !== "" && endDate != "") &&
                                            <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                                <DateRangePickerComponent
                                                    ref={daterange_picker_ref}
                                                    allowEdit={false}
                                                    focus={(e) => {
                                                        daterange_picker_ref.current.show()
                                                    }}
                                                    delayUpdate={true}
                                                    presets={presets}
                                                    change={(e) => {
                                                        setStartDate(e.startDate);
                                                        setEndDate(e.endDate);
                                                    }}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("EXPENSE", "").replace("_", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                            onChange={(event) => { setStatusType(event.value); }}
                                            value={statusType !== "All" ? statusTypeArray.find(elem => elem.value == statusType) : { label: "All", value: "All" }}
                                            placeholder="Select Status..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                expenseListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    expenseList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={totalExpenseListLength}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px">Expense Number</th>
                                                                            <th className="min-w-150px">Expense For</th>
                                                                            <th className="min-w-150px">Expense Date</th>
                                                                            <th className="min-w-150px">User</th>
                                                                            <th className="min-w-150px">Amount</th>
                                                                            <th className="min-w-150px">Recursive Status</th>
                                                                            <th className="min-w-150px">Timestamp</th>
                                                                            <th className="min-w-150px">Status</th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            expenseList.map((obj3, indx3) => {
                                                                                return (
                                                                                    <tr key={indx3}>
                                                                                        <td>
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.Expense_Number}</a>
                                                                                            <span className="text-muted fw-semibold text-muted d-block fs-7">Branch: {obj3.branch_name}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="badge badge-light-info">{obj3.expense_for}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.Expense_Date}</a>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="badge badge-secondary">{obj3.User}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6"> {obj3.currency_info.currency_symbol}&nbsp;{formatNumber(obj3.Amount, { ...formatNumberOptions, currencyFormat: obj3.currency_info.format, decimalPlaces: obj3.currency_info.decimal_place })}</a>
                                                                                        </td>

                                                                                        <td>
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.recursive_status}</a>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.add_date_time}</a>
                                                                                        </td>
                                                                                        <td>
                                                                                            <StatusBadge status={obj3.add_status} entity={"EXPENSE"} />
                                                                                            {/* <span className={obj3.add_status === "EXPENSE_PENDING_APPROVAL" ? "badge badge-light-warning" : obj3.add_status === "EXPENSE_DRAFT" ? "badge badge-secondary" : obj3.add_status === "EXPENSE_APPROVED" ? "badge badge-primary" : obj3.add_status === "EXPENSE_PAID" ? "badge badge-success" : obj3.add_status === "EXPENSE_CANCELLED" && "badge badge-danger"}>
                                                                                                {obj3.add_status === "EXPENSE_PENDING_APPROVAL" ? "Pending Approval" :
                                                                                                    obj3.add_status === "EXPENSE_DRAFT" ? "Draft" :
                                                                                                        obj3.add_status === "EXPENSE_APPROVED" ? "Approved" :
                                                                                                            obj3.add_status === "EXPENSE_PAID" ? "Paid" :
                                                                                                                obj3.add_status === "EXPENSE_CANCELLED" ? "Cancelled" :
                                                                                                                    obj3.add_status === "EXPENSE_REJECTED" && "Rejected"}
                                                                                            </span> */}
                                                                                        </td>
                                                                                        <td className="sticky-column">
                                                                                            {obj3.actions}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={totalExpenseListLength}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                state == 0 ?
                                    <>
                                        <div className="card-body pt-0">
                                            <div className="text-gray-500 fw-bold fs-5 mb-5">Expense List</div>
                                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                <div className="d-flex flex-stack flex-grow-1">
                                                    <div className="fw-bold">
                                                        <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                                        <div className="fs-6 text-gray-600"> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    state == 3 &&
                                    <PageError />
                    }
                </div >
            </div >

            <Modal show={approveModalShow} onHide={() => { setApproveModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{approveType === "final_approve" && <>Final</>} Approve Expense</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                Current Status is :<StatusBadge status={status} entity={"EXPENSE"} />
                                <br />
                                <h3 className="mt-3">Are you sure about {approveType === "final_approve" && <>& Final</>} Approve Payment?</h3>
                            </div>
                        </div>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setApproveModalShow(false) }} className="btn btn-secondary">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => {
                            if (approveType === "final_approve") {
                                approveExpenseSubmit(true, false, false, "", expense_id)
                            }
                            else {
                                approveExpenseSubmit(false, false, false, "", expense_id)
                            }
                        }} className="btn btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}><span className="indicator-label">{approveType === "final_approve" && <>Final </>}Approve </span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={ImageModalShow} onHide={() => { setImageModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setImageModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <img src={Image_src} style={{ height: "300px", padding: '25px', marginTop: '0' }} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setImageModalShow(false) }} className="btn btn-secondary">Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={paidStatusModalShow} onHide={() => { setPaidStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Pay Expense</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPaidStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="text-center">
                            Current Status is :<StatusBadge status={status} entity={"EXPENSE"} />
                            <h3 className="mt-3">Are you sure about pay expense?</h3>
                        </div>
                        <div className="mt-2">
                            <label className="required fs-5 fw-bold mb-2">Paid Through:</label>
                            <Select
                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                options={PaidThroughAccountlist}
                                onChange={(event) => { setPaidThroughAccount(event); }}
                                value={PaidThroughAccount}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setPaidStatusModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { approveExpenseSubmit(false, false, true, "", expense_id); }} className="btn btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} ><span className="indicator-label">Pay</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={StatusModalShow} onHide={() => { setReason(""); setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{cancel_type == "cancelled" ? <>Cancel Expense</> : <>Reject Expense</>}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setReason(""); setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />hy
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="text-center">
                            Current Status is : <StatusBadge status={status} entity={"EXPENSE"} /><br />
                            <h3 className="mt-3">Are you sure about {cancel_type == "cancelled" ? <>Cancelling Expense</> : <>Rejecting Expense</>}?</h3>
                        </div>
                        <div className="mt-2">
                            <label className="fs-5 fw-bold mb-2">Reason :</label>
                            <textarea className="form-control form-control-solid" rows="3" value={reason}
                                onChange={(e) => {
                                    setReason(e.target.value);
                                }}
                                placeholder={""}>
                            </textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setReason(""); setStatusModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { cancelExpense(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={CancelRecurringModalShow} onHide={() => { setCancelRecurringModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Recurring</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelRecurringModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                Current Status is : <StatusBadge status={status} entity={"EXPENSE"} />
                                <h3 className="mt-3">Are you sure about cancelling recurrence?</h3>
                            </div>
                        </div>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    {/* <button type="button" onClick={(e) => {setStatusModalShow(false)}} className="btn btn-secondary">Cancel</button> */}
                    {write && <form >
                        <button type="button" onClick={(e) => { cancelRecurrence(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Modal show={RemoveAttachmentModalShow} onHide={() => { setRemoveAttachmentModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Delete Expense Attachments</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setRemoveAttachmentModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure you want to delete this Expense Attachments?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setRemoveAttachmentModalShow(false) }} className="btn btn-secondary">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { removeattachments(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Delete</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Modal show={MakeRecurringModalShow} onHide={() => { handleRecurringExpenseModalClose() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Make Recurring Expense</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleRecurringExpenseModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="row mb-5 align-items-center">
                            <div className="col-12">
                                <label className="required fs-5 fw-bold mb-2">Recurring Expense Name</label>
                                <input type="text" className="form-control form-control-solid" value={profileName} onChange={(e) => { setprofileName(e.target.value) }} placeholder="Recurring Expense Name" />
                                {/* <span className="form-text text-muted">Please enter Recurring Expense Name.</span> */}
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">Start Date</label>
                            </div>
                            <div className="col-8">
                                <input type="date" className='form-control form-control-solid' value={scheduleStartDate} onChange={(e) => { setScheduleStartDate(e.target.value) }} />
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">Repeat Every</label>
                            </div>
                            <div className="col-3">
                                <input type="number" className='form-control form-control-solid' value={frequencyDetails.frequency} onChange={(e) => { setFrequencyDetails({ ...frequencyDetails, frequency: parseInt(e.target.value) }) }} />
                            </div>
                            <div className="col-5">
                                <Select
                                    options={["day", "week", "month", "year"].map(x => { return { label: x.charAt(0).toUpperCase() + x.slice(1), value: x } })}
                                    onChange={(val) => { setFrequencyDetails({ ...frequencyDetails, time_period: val.value }) }}
                                    value={{ label: frequencyDetails.time_period.charAt(0).toUpperCase() + frequencyDetails.time_period.slice(1), value: frequencyDetails.time_period }}
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                />
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">End Date</label>
                            </div>
                            <div className="col-8">
                                <input type="date" className='form-control form-control-solid' value={scheduleEndDate} onChange={(e) => { setScheduleEndDate(e.target.value) }} />
                            </div>
                        </div>

                        <div className="row mb-5 align-items-center">
                            <div className="col-6 col-md-4">
                                <label className="required fs-5 fw-bold">Any Time</label>
                            </div>
                            <div className='col-6 col-md-2'>
                                <div className="form-switch">
                                    <input className="form-check-input w-45px h-30px" type="checkbox" checked={allDayCheck} onChange={(e) => { setAllDayCheck(e.target.checked) }} />
                                </div>
                            </div>
                            {
                                !allDayCheck &&
                                <>
                                    <div className='col-3'>
                                        <input type="time" className='form-control form-control-solid' value={startTime} onChange={(e) => { setStartTime(e.target.value) }} disabled={allDayCheck} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { handleRecurringExpenseModalClose() }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { submitRecurringExpensedetails(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Save</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} styles={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>
                        {(Expense_details != null && write && (Expense_details.add_status == "EXPENSE_DRAFT" || Expense_details.add_status == "EXPENSE_PENDING_APPROVAL" || (Expense_details.add_status == "EXPENSE_APPROVED" && Expense_details.PaidButtonShow))) &&
                            <div className="dropdown">
                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fas fa-bars px-0"></i>
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {(Expense_details.add_status === "EXPENSE_DRAFT" || Expense_details.add_status == "EXPENSE_PENDING_APPROVAL") &&
                                        <li className="py-1"><a href={`/edit-expense-details/${Expense_details.unique_id}`} className={`dropdown-item cursor-pointer`}>Edit Details</a></li>
                                    }
                                    {(Expense_details.recurrence_expense_flag == false && (Expense_details.add_status !== "EXPENSE_CANCELLED" && Expense_details.add_status !== "EXPENSE_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { makeRecurring(Expense_details.unique_id); }} className={`dropdown-item cursor-pointer`}>Make Recurring</a></li>}
                                    {Expense_details.recurrence_expense_flag == true && Expense_details.recurrence_expense_status == "Active" &&
                                        <li className="py-1"><a onClick={(e) => { cancelRecurring(Expense_details.unique_id, Expense_details.recurrence_expense_status); }} className={`dropdown-item cursor-pointer`}>Cancel Recurring</a></li>}
                                    {Expense_details.PaidButtonShow &&
                                        <li className="py-1"><a onClick={(e) => { updateStatus(Expense_details.unique_id, "paid", Expense_details.add_status); }} className={`dropdown-item cursor-pointer`}>Pay Expense</a></li>}
                                    {(user_role == "Admin" && (Expense_details.add_status !== "EXPENSE_PAID" && Expense_details.add_status !== "EXPENSE_APPROVED" && Expense_details.add_status !== "EXPENSE_CANCELLED" && Expense_details.add_status !== "EXPENSE_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("cancelled"); updateStatus(Expense_details.unique_id, "status", Expense_details.add_status); }} style={{ cursor: "pointer" }} className={`dropdown-item cursor-pointer`}>Cancel</a></li>}
                                    {(user_role == "Admin" && (Expense_details.add_status !== "EXPENSE_PAID" && Expense_details.add_status !== "EXPENSE_APPROVED" && Expense_details.add_status !== "EXPENSE_CANCELLED" && Expense_details.add_status !== "EXPENSE_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("rejected"); updateStatus(Expense_details.unique_id, "status", Expense_details.add_status); }} className={`dropdown-item cursor-pointer`}>Reject</a></li>}
                                    {(Expense_details.ApproveButtonShow) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(Expense_details.unique_id, "approve", Expense_details.add_status); }} className={`dropdown-item cursor-pointer`}>Final Approve</a></li>}
                                    {(Expense_details.ApproveFinalButtonShow) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(Expense_details.unique_id, "approve", Expense_details.add_status); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                </ul>

                            </div>}
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Transaction</a>
                            </li>
                            {Expense_details != null && Expense_details.recurrence_expense_flag == true &&
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Recurrence" && "active"}`} onClick={(e) => { setnavtype("Recurrence"); }}>Recurrence details</a>
                                </li>}
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Attachments" && "active"}`} onClick={(e) => { setnavtype("Attachments"); }}>Attachments</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {(navtype === "Overview" && Expense_details !== null) ?
                        <>
                            <div
                                className="card border-primary mb-3 mt-2"
                                style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                            >
                                <div className="card-header cursor-pointer py-3">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bold m-0">
                                            {Expense_details.expense_number}
                                        </h3>
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Expense Date</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{moment(Expense_details.expense_date).format("ll")}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{Expense_details.branch_name}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Expense Type</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="badge badge-light-primary">{Expense_details.expense_type}</span>
                                            </div>
                                        </div>
                                        {Expense_details.expense_type !== "" &&
                                            <>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Expense For</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="badge badge-light-primary">{Expense_details.expense_for}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Expense User</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{Expense_details.expense_user_name}</span>
                                                    </div>
                                                </div>
                                            </>}
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Status
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <StatusBadge status={Expense_details.add_status} entity={"EXPENSE"} />
                                            </div>
                                        </div>
                                        {Expense_details.add_status === "PAID" &&
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Paid Through Account</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.account_head_name}`}</span>
                                                </div>
                                            </div>}
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.currency.currency_code}`}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Source Of Supply</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.source_of_supply}`}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Destination Of Supply</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.destination_of_supply}`}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Tax Detils</label>
                                            <div className="col-lg-8 fv-row">
                                                {Expense_details.gstin_details != null && <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.gstin_details.GstIn},${Expense_details.gstin_details.gst_treatment}`}</span>}
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Invoice</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{Expense_details.remarks}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        navtype === "Transactions" ?
                            <>
                                <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                    {Expense_details != null &&
                                        <div className="card-body p-9">
                                            <div>
                                                {
                                                    Expense_details.account_details.map((obj3, indx3) => {
                                                        return (
                                                            <>
                                                                <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Account Name</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.account_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Calculation Method</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.calculation_mode == "Tax_Exclusive" ? <>Tax Exclusive</> : <>Tax Inclusive</>}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {CurrencySymbol} {obj3.original_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    {obj3.tax !== null &&
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">Tax</label>
                                                                            <div className="col-lg-8">
                                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                                    {CurrencySymbol} {obj3.tax_amount}
                                                                                </span>
                                                                            </div>
                                                                        </div>}
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Total amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {CurrencySymbol} {obj3.total_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            navtype === "Recurrence" ?
                                <>
                                    {Expense_details != null &&
                                        <div className="card-body p-9">
                                            {additonalDetailsFlag !== true ?
                                                <>
                                                    <div
                                                        className="card border-primary mb-3 mt-2"
                                                        style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                                                    >
                                                        <div className="card-body p-3">
                                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Profile Name</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {Expense_recurrence_details.profile_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Start Date</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {moment(Expense_recurrence_details.start_date).format("ll")}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">End Date</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {moment(Expense_recurrence_details.end_date).format("ll")}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Any time check</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {Expense_recurrence_details.any_time_check ? <>True</> : <>False</>}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Frequency</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {Expense_recurrence_details.frequency_details.frequency + " " + Expense_recurrence_details.frequency_details.time_period}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                                    <div className="col-lg-8">
                                                                        <StatusBadge status={Expense_recurrence_details.add_status} entity={"EXPENSE"} />
                                                                        {/* {Expense_recurrence_details.add_status === "cancelled" ?
                                                                            <span className="badge badge-danger">Cancelled</span>
                                                                            :
                                                                            Expense_recurrence_details.add_status === "expired" ?
                                                                                <span className="badge badge-danger">Expired</span>
                                                                                :
                                                                                Expense_recurrence_details.add_status === "Active" &&
                                                                                <span className="badge badge-success">Active</span>

                                                                        } */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            }
                                        </div>
                                    }
                                </>
                                :
                                navtype === "Attachments" ?
                                    <>
                                        {Expense_details != null &&
                                            <div className="card-body p-9">
                                                {Expense_document_details.length > 0 &&
                                                    <div className="overflow-auto pb-5">
                                                        <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7">
                                                            {additonalDetailsFlag !== true ?
                                                                <>
                                                                    {Expense_document_details.map((obj, index) => {
                                                                        return (
                                                                            <>
                                                                                {getExtension(obj.file_name) == "pdf" ?
                                                                                    <div key={index} className="d-flex flex-aligns-center pe-10 pe-lg-20">
                                                                                        <img alt="" className="w-30px me-3" src="/assets/media/svg/files/pdf.svg" />
                                                                                        <div className="ms-1 fw-semibold">
                                                                                            <a target="_blank" href={(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/expense_documents/${organization_id}/`, (obj.file_name))} className="fs-6 text-hover-primary fw-bold">{obj.original_file_name.substring(0, obj.original_file_name.lastIndexOf('.'))}</a>
                                                                                            <div className="text-gray-400">1.9mb</div>
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    <div key={index} className="overlay me-10">
                                                                                        <div className="overlay-wrapper">
                                                                                            <img alt="img" className="rounded w-150px" src={(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/expense_documents/${organization_id}/`, (obj.file_name))} />
                                                                                        </div>
                                                                                        <div className="overlay-layer bg-dark bg-opacity-10 rounded">
                                                                                            <a onClick={() => showImage((`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/expense_documents/${organization_id}/`, (obj.file_name)))} className="btn btn-sm btn-primary btn-shadow me-1">View</a>
                                                                                            <a onClick={() => { setRemoveAttachmentDetails(obj); setRemoveAttachmentModalShow(true) }} className="btn btn-sm btn-danger btn-shadow">Delete</a>
                                                                                        </div>
                                                                                    </div>}
                                                                            </>
                                                                        )
                                                                    })}
                                                                </>
                                                                :
                                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                <div className="mb-2">
                                                    <Dropzone
                                                        getUploadParams={getUploadParams}
                                                        onChangeStatus={handleChangeStatus}
                                                        //LayoutComponent={CustomLayout}
                                                        PreviewComponent={Preview}
                                                        styles={{
                                                            dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                                            inputLabelWithFiles: { margin: '20px 3%' }
                                                        }}
                                                        maxFiles={3}
                                                        maxSizeBytes={1024 * 1024 * 2}
                                                        accept="image/*,.pdf"
                                                    />
                                                </div>
                                                {fileNames.length > 0 &&
                                                    <div className="text-end mb-1">
                                                        <button type="button" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => submitattachments(Expense_details.unique_id)} className="btn btn-sm btn-primary me-2">
                                                            <span className="indicator-label">Save</span>
                                                            <span className="indicator-progress">Please wait...
                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                            </span></button>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </>
                                    :
                                    navtype === "History" &&
                                    <>
                                        {Expense_details != null &&
                                            <div className="card-body p-9">
                                                {additonalDetailsFlag !== true ?
                                                    <>
                                                        {Expense_history_details.length > 0 && Expense_history_details.map((obj, index) => {
                                                            return (
                                                                <>
                                                                    <div key={index} className="m-0">
                                                                        <div className="d-flex align-items-sm-center mb-5">
                                                                            <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                                <div className="flex-grow-1 me-2">
                                                                                    <StatusBadge status={obj.expense_status} entity={"EXPENSE"} />
                                                                                    {(obj.expense_status === "EXPENSE_PENDING_APPROVAL" || obj.expense_status === "EXPENSE_DRAFT") && <span className="badge badge-light-primary">{obj.operation == "create" ? <>Create</> : <>Update</>}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline">
                                                                            <div className="timeline-item align-items-center mb-7">
                                                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                    <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                    <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                                </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{moment(obj.timestamp).format("lll")} </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline-item align-items-center">
                                                                                <div className="timeline-line w-40px"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                    <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                    <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                                </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{obj.user}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {Expense_history_details.length > 1 &&
                                                                        <div className="separator separator-dashed my-6"></div>
                                                                    }
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                    :
                                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                }
                                            </div>
                                        }
                                    </>
                    }
                </div>
            </Drawer>
        </>
    );
};

export default ExpenseList;
